import React, {useEffect, useState} from "react";
import I18n from "i18n-js";
import $ from "jquery";
import ErrorModal from "./ErrorModal";
import AlertPopup from "./AlertPopup";
import {
  customToString,
  isDefined
} from "../../utils/utils";

const UserAccountDeletor = ({ userId, userFirstName, aigradingEmail, onlyLink, userEmail, currentUserId, isSuperadminUser }) => {

  const [ showModal, setShowModal ] = useState(false);
  const [ showConfirmationPopup, setShowConfirmationPopup ] = useState(false);
  const [ slide, setSlide ] = useState(0);
  const [ password, setPassword ] = useState(null);
  const [ showWrongPasswordMessage, setShowWrongPasswordMessage ] = useState(false);
  const [ deletionChoice, setDeletionChoice ] = useState(null);
  const [ deletionReason, setDeletionReason ] = useState(null);
  const [ showErrorModal, setShowErrorModal ] = useState(false);


  useEffect(() => {
    $('#carousel').carousel({ interval: false });
  }, []);


  useEffect(() => {
    setShowWrongPasswordMessage(false);
  }, [password]);


  // Funzione che effettua la richiesta al server di invio dell'email all'utente che gli permetterà di avviare la
  // procedura di cancellazione del suo account
  const handleSendDeleteAccountEmail = () => {
    let url = `/users/${userId}/delete`;

    fetch(url, {
      method: "GET"
    })
      .then((response) => {
        if (!response.ok)
          throw Error("An error occour during getting data from database");
        else
          return response.json();
      })
      .then((data) => {
        setShowModal(false);
        setShowConfirmationPopup(true);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        setShowErrorModal(true);
      });
  }


  // Funzione che gestisce l'avanzamento della procedura di cancellazione account dell'utente
  const handleOnClick = () => {
    if (slide === 0 && password?.length >= 6) {
      let url = `/users/${userId}/check_password`;

      // La password viaggia nel body della richiesta e non nell'url: nella query string i caratteri speciali
      // (#, &, +, %) arrivavano alterati al server, che la considerava quindi errata
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ''
        },
        body: JSON.stringify({ password: password })
      })
        .then((response) => {
          // Solo il 400 significa password errata: ogni altro errore viene segnalato come errore generico
          if (response.status === 400)
            setShowWrongPasswordMessage(true);
          else if (!response.ok)
            throw Error("An error occour during checking the password");
          else {
            setSlide(slide + 1);
            $('#carousel').carousel('next');
          }
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }

    else if (slide === 1 && deletionReason?.length >= 10) {
      setSlide(slide + 1);
      $('#carousel').carousel('next');
    }

    else {
      let url = `/users/${userId}/confirm_account_deletion`;

      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password: password, deletion_reason: deletionReason, email: userEmail })
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json();
        })
        .then((data) => {
          window.location = isDefined(currentUserId) && userId !== currentUserId && isSuperadminUser ? "/backoffice/users.html" : "/index.html"
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  return (
    <React.Fragment>
      {
        onlyLink ?
          <div className="text-right my-5 py-5">
            <small>
              {I18n.t("js.deletionAccount.link")}&nbsp;
              <span className="text-aig-gradient cursor-pointer"
                    onClick={() => setShowModal(true)}
              >
                {I18n.t("js.deletionAccount.here")}
              </span>
            </small>
          </div>
        :
          <div id="carousel" data-ride="carousel"
               className="container my-5 carousel slide d-flex justify-content-between flex-directions-column position--relative"
          >
            <div className="carousel-inner min-h-vh-50 px-3">
              <div className="carousel-item active pt-4">
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel1.text1")}{userFirstName}!</p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel1.text2")}</p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel1.text3")}</p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel1.text4")}</p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel1.text5")}</p>
                <p className="mt-5">{I18n.t("js.deletionAccount.closingCarousel.panel1.text6")}</p>
                <p>
                  {I18n.t("js.deletionAccount.closingCarousel.panel1.text7")}&nbsp;
                  <a href={`mailto: ${aigradingEmail}`} className="text-aiBlue">
                    {aigradingEmail}
                  </a>&nbsp;
                  {I18n.t("js.deletionAccount.closingCarousel.panel1.text8")}
                </p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel1.text9")}</p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel1.text10")}</p>
                <p className="mt-5">{I18n.t("js.deletionAccount.closingCarousel.panel1.text11")}:</p>

                <div className="row w-100">
                  <div className="col-12 col-md-6 col-lg-4">
                    <input type="password"
                           id="passwordField"
                           name="passwordField"
                           placeholder={I18n.t("js.deletionAccount.yourPassword")}
                           className="form-control"
                           autoComplete="new-password"
                           autoCapitalize="off"
                           autoCorrect="off"
                           spellCheck={false}
                           onChange={(e) => setPassword(e.target.value)} />
                  </div>
                  <div className="col-12 col-md-6 col-lg-8"></div>
                  {
                    showWrongPasswordMessage &&
                    <div className="col-12 pt-4 text-aig-gradient">
                      {I18n.t("js.deletionAccount.wrongPassword")}
                    </div>
                  }
                </div>
              </div>

              <div className="carousel-item pt-4">
                <p className="text-weight-500">{I18n.t("js.deletionAccount.closingCarousel.panel2.enterReason")}</p>
                {
                  [
                    ['key1', I18n.t("js.deletionAccount.closingCarousel.panel2.deletionReasons.choice1")],
                    ['key2', I18n.t("js.deletionAccount.closingCarousel.panel2.deletionReasons.choice2")],
                    ['key3', I18n.t("js.deletionAccount.closingCarousel.panel2.deletionReasons.choice3")],
                    ['key4', I18n.t("js.deletionAccount.closingCarousel.panel2.deletionReasons.choice4")],
                    ['other', I18n.t("js.deletionAccount.closingCarousel.panel2.deletionReasons.other")]
                  ].map((reason) => {
                    return <div key={reason[0]} className="my-3 cursor-pointer">
                      <input type="radio"
                             value={reason[0]}
                             id={reason[0]}
                             className="aiG-radio custom-control-input cursor-pointer"
                             checked={deletionChoice === reason[0]}
                             onChange={(e) => {
                               setDeletionChoice(reason[0]);
                               setDeletionReason(reason[0] !== 'other' ? reason[1] : null)
                             }}
                      />
                      <label className="pr-3 ml-3 font-weight--normal aiG-label-radio custom-control-label cursor-pointer" htmlFor={reason[0]}> {reason[1]}</label>
                    </div>
                  })
                }

                {
                  deletionChoice === 'other' &&
                  <textarea
                    className="form-control mt-3"
                    autoComplete="off"
                    id="deletionReason"
                    name="deletionReason"
                    rows="6"
                    value={customToString(deletionReason)}
                    placeholder={I18n.t("js.deletionAccount.closingCarousel.panel2.deletionReasons.typeYourReason")}
                    onChange={(e) => setDeletionReason(e.target.value) }
                  />
                }
              </div>

              <div className="carousel-item pt-4">
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel3.text0")}</p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel3.text1")}</p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel3.text2")}</p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel3.text3")}</p>
                <p className="mt-5">{I18n.t("js.deletionAccount.closingCarousel.panel3.text4")}</p>
                <p>
                  {I18n.t("js.deletionAccount.closingCarousel.panel3.text5")}&nbsp;
                  <a href={`mailto: ${aigradingEmail}`} className="text-aiBlue">
                    {aigradingEmail}
                  </a>&nbsp;
                  {I18n.t("js.deletionAccount.closingCarousel.panel3.text6")}
                </p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel3.text7")}</p>
                <p>{I18n.t("js.deletionAccount.closingCarousel.panel3.text8")}</p>
                <p className="mt-5">{I18n.t("js.deletionAccount.closingCarousel.panel3.text9")}</p>
              </div>
            </div>

            <div className="d-flex justify-content-end my-5">
              <a href={`/users/${userId}`}
                 className="btn-standard-outline br-20px text-center mr-4 w-120px btn-standard-outline-resized text-weight-500">
                {I18n.t('js.common.button.cancel').toUpperCase()}
              </a>

              <button
                className="btn-standard bg-aig-gradient text-light br-20px text-center min-width-120px-imp px-2 btn-standard-resized pt-4px-imp h-35px text-weight-500"
                disabled={(slide === 0 && (!password || password.length < 6)) || (slide === 1 && (!deletionReason || deletionReason.length < 10))}
                onClick={handleOnClick}
              >
                {slide === 2 ? I18n.t('js.deletionAccount.deleteAccount').toUpperCase() : I18n.t('js.common.button.confirm').toUpperCase()}
              </button>
            </div>
          </div>
      }




      <AlertPopup
        showAlertPopup={showModal}
        onSuccess={handleSendDeleteAccountEmail}
        onDiscard={() => setShowModal(false)}
        customHtmlPopupContent={
          `<div className="pt-5">
            <p>${I18n.t('js.deletionAccount.starterPopup.text1')}</p>
            <p>${I18n.t('js.deletionAccount.starterPopup.text2')}</p>
            <p>${I18n.t('js.deletionAccount.starterPopup.text3')}</p>
            <p>${I18n.t('js.deletionAccount.starterPopup.text4')}</p>
            <p>
              ${I18n.t('js.deletionAccount.starterPopup.text5')}&nbsp;
              <a href="mailto: ${aigradingEmail}" className="text-aiBlue">${aigradingEmail}</a>${I18n.t('js.deletionAccount.starterPopup.text6')}
            </p>
            <p>${I18n.t('js.deletionAccount.starterPopup.text7')}</p>
          </div>`
        }
        cancelButtonText={`${I18n.t('js.common.button.cancel')}`}
        confirmButtonText={`${I18n.t('js.deletionAccount.startDeletionAccount')}`}
      />

      <AlertPopup
        showAlertPopup={showConfirmationPopup}
        onSuccess={() => setShowConfirmationPopup(false)}
        onDiscard={() => setShowConfirmationPopup(false)}
        customHtmlPopupContent={
          `<div className="pt-5">
            <p>${I18n.t('js.deletionAccount.checkEmail.text1')}</p>
            <p>${I18n.t('js.deletionAccount.checkEmail.text2')}</p>
            <p>${I18n.t('js.deletionAccount.checkEmail.text3')}</p>
          </div>`
        }
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.ok').toUpperCase()}`}
      />

      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />
    </React.Fragment>
  );
};

export default UserAccountDeletor;